module.exports = __webpack_public_path__ + "img/search-icon.65dd63f1.svg";